import dayjs from "dayjs";
import { Breadcrumb, Flex, Tabs, Button } from "antd";
import TabAbout from "./TabAbout";
import TabProposals from "./TabProposals";

import StyledContainer from "./style";

import { setPhoneMask } from "../../../../../../../../utils/helper/general";

import { ReactComponent as DotSeparator } from "../../../../image/dot_separator.svg";

const SectionDetailsClient = ({
  clientData,
  disableEdit,
  itemsBreadcrumb,
  managerEmail,
  onClickEditInfo,
  onClickProposalOpen,
  organization,
  productsList,
}) => {
  const getUserTypeLabel = () => {
    if (
      clientData?.valueMap?.leadInitial?.isConverted ||
      clientData?.userType === "Registered" ||
      clientData?.userType === "ConvertedProspect"
    ) {
      return "Client";
    } else {
      return "Lead";
    }
  };

  const items = [
    {
      children: (
        <TabProposals
          clientData={clientData}
          organization={organization}
          productsList={productsList}
          managerEmail={managerEmail}
        />
      ),
      key: "proposal",
      label: "Proposals",
    },
    {
      children: (
        <TabAbout
          clientData={clientData}
          disableEdit={disableEdit}
          onClickEditInfo={onClickEditInfo}
        />
      ),
      key: "about",
      label: "About",
    },
  ];

  return (
    <StyledContainer>
      <Breadcrumb
        items={itemsBreadcrumb}
        separator={<DotSeparator style={{ color: "#C9C8C8" }} />}
      />

      <header>
        <Flex gap={4} vertical>
          <Flex justify="space-between">
            <h2>
              {clientData?.firstName} {clientData?.lastName}
            </h2>

            <Button
              onClick={() => {
                onClickProposalOpen(
                  clientData?.email,
                  clientData?.advisorEmail
                );
              }}
              shape="round"
              size="small"
              style={{
                background: "#DBE245",
                fontWeight: 800,
              }}
            >
              Launch Planning
            </Button>
          </Flex>

          <Flex align="center" gap={8}>
            {getUserTypeLabel()}
            <DotSeparator />
            {clientData?.email}
            {clientData?.personalInfo?.phoneNumber && (
              <>
                <DotSeparator />
                {setPhoneMask(clientData?.personalInfo?.phoneNumber)}
              </>
            )}
            <DotSeparator />
            Last Login:{" "}
            {clientData?.lastAdvisorLoginTime?.$date
              ? dayjs(clientData.lastAdvisorLoginTime.$date).format(
                  "MM/DD/YYYY h:mma"
                )
              : "N/A"}
          </Flex>
        </Flex>
      </header>

      <Tabs items={items} />
    </StyledContainer>
  );
};

export default SectionDetailsClient;
